module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-280.694378a.woff2";